import {
    Menu,MenuButton,MenuList,MenuItem,MenuItemOption,MenuGroup,MenuOptionGroup,MenuDivider, IconButton,
  } from '@chakra-ui/react'
  import { BrowserRouter } from "react-router-dom";
  import { HashLink as Link} from "react-router-hash-link"
  import Logo from "../image/n.jpg"
  import { HamburgerIcon} from '@chakra-ui/icons'
export default function Nav_ham(){
    const DownloadResume = () => {
        // using Java Script method to get PDF file
        fetch('fw18_0273_Nikhil_Walwatkar_ Resume.pdf').then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'Nikhil-Walwatkar-Resume.pdf';
                alink.click();
            })
        })
    }
    return (
        <div className='Con'>
         <div className="Logo_box_hamburg" ><img src={Logo} alt="brand_logo" className="brand_logo" /></div>
         <div className="hambargur_comp">

        <Menu>
  <MenuButton
    as={IconButton}
    aria-label='Options'
    icon={<HamburgerIcon />}
    variant='outline'
    bg="orange"
  />
  <MenuList>
    <BrowserRouter>
    <Link to={"#home"} smooth >
    <MenuItem >
      <p>Home</p>
    </MenuItem>
      </Link>

    <Link to={"#about"} smooth >
    <MenuItem >
      <p>About</p>
    </MenuItem>
    </Link>
    
    <Link to={"#skill"} smooth ><MenuItem ><p>Skills</p></MenuItem></Link>
    
    <Link to={"#project"} smooth >
    <MenuItem>
      <p>Projects</p>
    </MenuItem>
      </Link>

    <Link to={"#contect"} smooth >
    <MenuItem>
      <p>Contact</p>
    </MenuItem>
      </Link>

    <a href="https://drive.google.com/file/d/1DDev4bDLA1AmDuyomIR_0jPF5ZGvOnmx/view?usp=sharing" onClick={DownloadResume} target="blank" >
    <MenuItem >
      Resume
    </MenuItem>
      </a>
    </BrowserRouter>
  </MenuList>
</Menu>

</div>
        </div>
    )
}